// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13tVc","tabsBox":"styles_tabsBox__1Bal1","createButton":"styles_createButton__1EYuN"};